import React from 'react';
import { CHECKOUT_URL, LOGO_URL } from '../data/copy';
import { trackPackAddToCart } from '../utils/metaPixel';
export function TopBar() {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackPackAddToCart('topbar');
    event.preventDefault();
    const opened = window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
    if (!opened) {
      try {
        ;
        (window.top ?? window).location.href = CHECKOUT_URL;
      } catch {
        window.location.href = CHECKOUT_URL;
      }
    }
  };
  return <div className="sticky top-0 z-40 w-full border-b border-bone/10 bg-abyss/90 backdrop-blur" data-id="element-161" data-mp="2ltws141lawus">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-4 sm:h-16 sm:px-8" data-id="element-162" data-mp="2h1dc40ffjpmt">
        <div className="flex min-w-0 items-center gap-2.5" data-id="element-163" data-mp="2c3229pp4xf4l">
          <img src={LOGO_URL} alt="Charly Baits" className="h-9 w-9 shrink-0 rounded-full object-cover object-left ring-1 ring-chartreuse/40 sm:h-10 sm:w-10" data-id="element-164" data-mp="39j8yvx9g2stx" />
          <span className="truncate font-display text-lg uppercase leading-none tracking-wide text-bone sm:text-xl" data-id="element-165" data-mp="24zj8gdio669">
            Charly Baits
          </span>
        </div>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="shrink-0 bg-chartreuse px-3.5 py-2 font-cond text-sm uppercase leading-none tracking-wide text-abyss transition-colors hover:bg-[#d8ff3d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-chartreuse/60 sm:px-5 sm:py-2.5 sm:text-base" data-id="element-166" data-mp="3ol2arusupgaa">
          Comprar $399
        </a>
      </div>
    </div>;
}